<div class="typography typography-body typography-xs gray-600">
  2016-{{ currentYear }}&nbsp;&#169;&nbsp;Хеликс
</div>
